import { type FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { titleCase } from "title-case";

import { useURLViewID } from "@/app-utils/hooks/useUrl.ts";
import { pluralizeWord } from "@/app-utils/string.ts";
import { type InputTableQuerySpec, type Protein } from "@/graphql.ts";
import { updateLastOpenProteinFeatureTableSpec } from "@/redux/modules/protein.ts";
import { loadView } from "@/redux/modules/saved-view.ts";
import { type IAppState } from "@/redux/reducer.ts";
import { type ReduxDispatch } from "@/redux/redux-utils.ts";
import { ENTITY_TYPE, FEATURE_DISPLAY_NAME } from "@/settings/settings.ts";
import { OrthologTypeSelector } from "@/ui-modules/entities/OrthologTypeSelector.tsx";

import ProteinRelatedEntitiesView from "./ProteinRelatedEntitiesView.js";

export const ProteinRelatedOrthologsView: FC = () => {
  const dispatch = useDispatch<ReduxDispatch>();
  const viewId = useURLViewID();
  const protein = useSelector<IAppState, Protein>((state) => state.protein.protein);
  const lastOpenFeatureTableSpec = useSelector<IAppState, InputTableQuerySpec>(
    (state) => state.protein.lastOpenFeatureTableSpec,
  );

  useEffect(() => {
    void dispatch(loadView(viewId!)).then((view) => {
      dispatch(updateLastOpenProteinFeatureTableSpec(view?.state?.tableView?.tableQuerySpec));
    });
  }, []);

  return (
    <ProteinRelatedEntitiesView
      subtitle={`List of ${pluralizeWord(
        titleCase(FEATURE_DISPLAY_NAME[lastOpenFeatureTableSpec?.resultType] ?? "ortholog"),
      )}`}
      middleToolbarElement={<OrthologTypeSelector protein={protein} />}
      relatedEntitiesType={lastOpenFeatureTableSpec?.resultType}
      relatedEntitiesSubType={lastOpenFeatureTableSpec?.resultSubTypeId}
      expectedEntityType={lastOpenFeatureTableSpec?.resultType}
    />
  );
};
